import CSSSticky from 'app/common/ui-components/css-sticky'
import PlainPaging from 'app/common/ui-next/plain-paging'

import styles from './OrgsOrdersFooter.scss'


type Props = {
  total: number,
  pageSize: number,
  currentPage: number,
  currentPageSize: number,
  onPage?: (page: number) => void,
}

const OrgsOrdersFooter = ({ total, pageSize, currentPage, currentPageSize, onPage }: Props) => {
  return (
    <CSSSticky
      number={-1}
      shadowClassName={styles.stickyBottom}
      className={styles.footer}
    >
      <div className={styles.pager}>
        <PlainPaging
          total={total}
          perPage={pageSize}
          currentPageIndex={currentPage - 1}
          currentPageSize={currentPageSize}
          onPage={onPage}
        />
      </div>
    </CSSSticky>
  )
}

export default OrgsOrdersFooter
